import React, { useState } from "react"
import Offcanvas from 'react-bootstrap/Offcanvas'
import Button from 'react-bootstrap/Button'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import TooltipX from 'react-bootstrap/Tooltip'
import XAccess from "../components/XAccess";
import XMembers from "../components/XMembers";
import XDocz from "../components/XDocz";
import XReportz from "../components/XReportz"
import gear from "../images/gear.png"
import AdminSite from "../components/AdminSite"
import XRSVPList from "../components/XRSVPList"

import EventSuite from '../components/EventSuite';




export default function Admin(props) {
    const [theme, setTheme] = useState(localStorage.getItem('app-theme') || 'dark');

    const [showCanvas, setShowCanvas] = useState(false);
    const handleCloseCanvas = () => setShowCanvas(false);
    const handleShowCanvas = () => setShowCanvas(true);

    return (
        <>


            <Button onClick={() => setShowCanvas(true)}>
                <img
                    src={gear}
                    alt="Admin"
                    className="thumb hoverX"
                />  <br></br>
                <span>Admin</span>
            </Button>

            <Offcanvas show={showCanvas} onHide={handleCloseCanvas} backdropClassName="adminBackdrop" placement="top"  className="bg-dark" >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>      <h3 className="modified xTitle animated rollIn ">
                        Admin
                    </h3></Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="padding squiggleX">
                    <div className="arrow_box_top">
                        <XReportz></XReportz>
                        <XAccess></XAccess>
                        <XDocz public={false}></XDocz>
                        <XMembers theme={"dark"}></XMembers>
                        <AdminSite></AdminSite>
                        <XRSVPList></XRSVPList>
                        <EventSuite
                            theme="dark"
                            currentUser={localStorage.getItem('email')}
                            isAdmin={true} // Enables the 🗓️ toggle button
                        />
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
}